<template>
  <div class="head">
    <div class="container">
      <div class="nav">
        <ul>
          <li
            v-for="(item,index) in navList"
            :key="index">
            <a :href="item.url">{{item.name}}</a>
          </li>
        </ul>
      </div>
      <div class="loginBox">
        <button>
          <a href="http://pt.gaozhaoedu.com/login/register">注册激活</a>
        </button>
        <button>
          <a href="http://pt.gaozhaoedu.com/login">登录系统</a>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "headComponent",  // 页头
    data() {
      return {
        navList: [
          {
            name: '首页',
            url: 'http://www.gaozhaoedu.com/'
          },
          {
            name: '生涯规划',
            url: 'http://www.gaozhaoedu.com/sygh.html'
          },
          {
            name: '名师优课堂',
            url: 'http://www.gaozhaoedu.com/msjt.html'
          },
          {
            name: '新高考改革',
            url: 'http://www.gaozhaoedu.com/gkxk.html'
          },
          {
            name: '志愿填报',
            url: 'http://www.gaozhaoedu.com/zytb.html'
          },
          {
            name: '志愿填报专家一对一',
            url: 'http://pt.gaozhaoedu.com/login/senior-apply'
          },
          {
            name: '平台介绍',
            url: 'http://www.gaozhaoedu.com/ptjs.html#/'
          },
        ]
      }
    },
    created() {

    },
    methods: {}
  }
</script>

<style scoped lang="scss">
  @import "../style/common";
  .head {
    height: 60px;
    background-color: #21252b;
    .container{
      display: flex;
      justify-content: space-between;
      max-width: 1200px;
      margin: auto;
      line-height: 60px;
      .nav{
        ul{
          display: flex;
          li{
            padding: 0 16px;
            a{
              color: #C4C4C4;
              font-size: 16px;
              padding-bottom: 4px;
            }
            a:hover{
              border-bottom: 2px solid #C4C4C4;
            }
          }
        }
      }
      .loginBox{
        button{
          background-color: #1f72ff;
          padding: 5px 10px;
          border: none;
          margin: 0 6px;
          cursor: pointer;
          a{
            color: #fff;
            font-size: 15px;
          }
        }
        button:last-child{
          background-color: #f00;
        }
      }
    }
  }
</style>
